import React from 'react';
import Globe from 'lucide-react/dist/esm/icons/globe';
import ArrowUpRight from 'lucide-react/dist/esm/icons/arrow-up-right';
import { getTravelKitUrl } from '../../utils/travelKitUrl';
import { TRAVEL_KIT_LANG_BY_LOCALE } from '../../utils/travelKitLocale';
import { buildTravelKitToken } from '../ExportOptions/TravelKitLinkConstructor/tokenHelper';

// Same versioned token as the travel kit constructor. The adviser and client name are
// only passed in when the export already prints them, so the link reveals nothing the
// paper does not; the insurer is left out because an export can cover several.
export function buildTravelEmergencyHref({ language, adviserId, clientName }) {
  const token = buildTravelKitToken({ adviserId, lang: TRAVEL_KIT_LANG_BY_LOCALE[language] });
  const name = (clientName || '').trim();
  return `${getTravelKitUrl()}/?p=${token}${name ? `&n=${encodeURIComponent(name)}` : ''}`;
}

export default function TravelEmergencyLink({ show = true, intl, outputFormat, language, adviserId, clientName }) {
  // A PNG cannot be clicked, so the line would point to a page nobody can open from it.
  if (!show || outputFormat === 'png') return null;

  const href = buildTravelEmergencyHref({ language: language || intl.locale, adviserId, clientName });
  return (
    <div className="export-travel-emergency-link">
      <a href={href} target="_blank" rel="noopener noreferrer">
        <Globe size={22} aria-hidden />
        <span>{intl.formatMessage({ id: 'export-travel-emergency-link' })}</span>
        <ArrowUpRight size={18} aria-hidden />
      </a>
    </div>
  );
}
